import React from "react";
import bg from "../../assets/img/bg/bg.jpg";

export default function Bradcom() {

  return (
      <section style={{maxWidth: "2380px", margin: "0 auto"}}>

              <img
                src={bg}
                alt="img"
                className="bradcom-img"
              />

      </section>
  );
}
